
<ui-entity-detail [docId]="docId" (back)="nav.back()"></ui-entity-detail>

